'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _util = require('./model/util');

var _util2 = _interopRequireDefault(_util);

var _events = require('events');

var _model = require('./model');

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventPasser = _util2.default.eventPasser,
    getInstance = _util2.default.getInstance;

var Cart = function (_EventEmitter) {
  (0, _inherits3.default)(Cart, _EventEmitter);

  function Cart(client) {
    (0, _classCallCheck3.default)(this, Cart);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Cart.__proto__ || (0, _getPrototypeOf2.default)(Cart)).call(this));

    _util2.default.setClient(client);
    return _this;
  }

  (0, _createClass3.default)(Cart, [{
    key: 'init',
    value: function init() {
      this.model = (0, _model2.default)();
      this.modelEvents();
      this.model.init();
    }
  }, {
    key: 'modelEvents',
    value: function modelEvents() {
      var _this2 = this;

      ['init', 'show-loading', 'hide-loading', 'error', 'hint-toast', 'hint-alert', 'refresh-preview', 'send-to-order'].forEach(function (event) {
        eventPasser.on(event, function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
      });
    }

    // ipos only

  }, {
    key: 'getStock',
    value: function getStock(spvId) {
      return this.model.getStock(spvId);
    }

    // ipos only

  }, {
    key: 'getGiftStock',
    value: function getGiftStock(guid) {
      return _util2.default.getInstance(guid).getStock();
    }

    // ipos only

  }, {
    key: 'subGiftPack',
    value: function subGiftPack(guid) {
      _util2.default.getInstance(guid).subCount();
    }

    // ipos only

  }, {
    key: 'addGiftPack',
    value: function addGiftPack(guid) {
      return _util2.default.getInstance(guid).addCount();
    }

    // ipos only

  }, {
    key: 'canGiftPackAdd',
    value: function canGiftPackAdd(guid) {
      _util2.default.getInstance(guid).compute();
    }

    // // ipos only
    // isAllFromStore (guid) {
    //   util.getInstance(guid).isAllFromStore()
    // }

  }, {
    key: 'refreshPreview',
    value: function refreshPreview() {
      this.model.refreshPreview();
    }
  }, {
    key: 'reloadGroup',
    value: function reloadGroup() {
      this.model.reloadGroup();
    }
  }, {
    key: 'addPack',
    value: function addPack(pack) {
      this.model.addPack(pack);
    }
  }, {
    key: 'getVariant',
    value: function getVariant(productId) {
      return this.model.getVariant(productId);
    }
  }, {
    key: 'removeAllPacks',
    value: function removeAllPacks() {
      this.model.removeAllPacks();
    }
  }, {
    key: 'deletePacks',
    value: function deletePacks(packs) {
      return this.model.deletePacks(packs);
    }
  }, {
    key: 'favorite',
    value: function favorite(packs) {
      return this.model.favorite(packs);
    }
  }, {
    key: 'editMode',
    value: function editMode(val) {
      this.model.editMode(val);
    }
  }, {
    key: 'submit',
    value: function submit(packs) {
      return this.model.submit(packs);
    }

    // too complex to pass user action to Model
    // so just pass user action to model instance directly

  }, {
    key: 'setCount',
    value: function setCount(guid, count) {
      getInstance(guid).setCount(count);
    }

    // ipos only

  }, {
    key: 'stockRefreshPreview',
    value: function stockRefreshPreview(groupGuid, packGuid) {
      getInstance(groupGuid).stockRefreshPreview(packGuid);
    }
  }, {
    key: 'setVariant',
    value: function setVariant(guid, _ref) {
      var result = _ref.result,
          variant = _ref.variant;

      return getInstance(guid).setVariant({ result: result, variant: variant });
    }
  }, {
    key: 'addToCart',
    value: function addToCart(guid) {
      var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      return getInstance(guid).addToCart(count);
    }
  }, {
    key: 'groupCheckboxTap',
    value: function groupCheckboxTap(guid) {
      // group all selected
      getInstance(guid).groupCheckboxTap(guid);
    }
  }, {
    key: 'cancelAddible',
    value: function cancelAddible(guid) {
      return getInstance(guid).cancelAddible();
    }
  }, {
    key: 'toggleSelect',
    value: function toggleSelect(guid) {
      getInstance(guid).toggleSelect();
    }
  }, {
    key: 'packCheckboxTap',
    value: function packCheckboxTap(guid) {
      // group single selected
      getInstance(guid).packCheckboxTap();
    }
  }, {
    key: 'countTap',
    value: function countTap(guid, action) {
      getInstance(guid).countTap(action);
    }
  }, {
    key: 'labelTap',
    value: function labelTap(guid) {
      getInstance(guid).labelTap();
    }
  }, {
    key: 'addPackCount',
    value: function addPackCount(packId) {
      var pack = this.findPack(packId, this.data.groups);
      return this.model.setCount(pack.count + 1, packId);
    }
  }, {
    key: 'subPackCount',
    value: function subPackCount(packId) {
      var pack = this.findPack(packId, this.data.groups);
      return this.model.setCount(pack.count - 1, packId);
    }
  }, {
    key: 'findPack',
    value: function findPack(id, groups) {
      var _this3 = this;

      var pack = void 0;
      groups.some(function (group) {
        result = _this3.find(id, group);
        result && (pack = result);
        return result;
      });
      return pack;
    }
  }, {
    key: 'find',
    value: function find(id) {
      var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var rule = arguments[2];

      rule = rule ? rule : function (sourceId, item) {
        return sourceId === item.id;
      };
      return arr.filter(function (item) {
        return rule(id, item);
      })[0];
    }
  }]);
  return Cart;
}(_events.EventEmitter);

exports.default = Cart;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/index.js
// module id = 1159
// module chunks = 0